import {
  IconNameEnum,
  useModuleBEM,
  usePackagesStyles,
} from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { PackageSearch } from "@tenant/packages";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HomePagePackageSearch.module.scss";
import { useHomePagePackageSearch } from "./hooks";

export type HomePagePackageSearchComponentProps = PlatformComponentProps;

const COMPONENT_KEY = "HomePagePackageSearch";

export const HomePagePackageSearch = ({
  children,
  className,
}: HomePagePackageSearchComponentProps) => {
  const styles = usePackagesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { handlers, text } = useHomePagePackageSearch();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("search")}>
        <PackageSearch />
      </div>
      <div className={cn("search-entry")}>
        <button
          type="button"
          onClick={() => handlers.handleMobileRedirect()}
          className={cn("start-search-button")}
        >
          <Icon iconName={IconNameEnum.search} className={cn("button-icon")} />
          {text.mobileButtonLabel}
        </button>
      </div>
      {children}
    </div>
  );
};
